import { APP_BRANDING_CONFIG_SERVICE, IAppBrandingConfigService } from '../app-branding-config';
import { enableSound, playSound } from './sound-notifications.service.utils';
import { IBackgroundService } from '../../interfaces';
import { inject, injectable } from 'inversify';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../session-lifecycle';
import { ISoundNotificationsAdapterService, SOUND_NOTIFICATIONS_ADAPTER_SERVICE } from '../message-adapters/sound-notifications-adapter';
import { takeUntil } from 'rxjs/operators';

@injectable()
export class SoundNotificationsService implements IBackgroundService {
    @inject(SOUND_NOTIFICATIONS_ADAPTER_SERVICE) private readonly soundNotificationsAdapter: ISoundNotificationsAdapterService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;
    @inject(APP_BRANDING_CONFIG_SERVICE) private readonly appBrandingConfigSrv: IAppBrandingConfigService;

    private isSoundEnabled = false;

    async start(): Promise<void> {
        const notificationSoundPath = (await this.appBrandingConfigSrv.get()).notification?.audio;

        if (Boolean(notificationSoundPath)) {
            this.soundNotificationsAdapter.soundNotificationsObservable().pipe(
                takeUntil(this.sessionLifeCycle.destroyObservable()),
            ).subscribe(({ notifications }) => {
                if (!this.isSoundEnabled) {
                    enableSound();
                    this.isSoundEnabled = true;
                }
                playSound(notificationSoundPath, notifications.length);
            });
        }
    }
}
